import React from "react";
import { Routes, Route } from "react-router-dom";
import ConnectCams from "../pages/ConnectCams";
import ConnectionFailed from "../pages/ConnectionFailed";
import ConsentDeny from "../pages/ConsentDeny";
import ConsentDetails from "../pages/ConsentDetails";
import SuccessRedirect from "../pages/SuccessRedirect";
import UserBankAccount from "../pages/UserBankAccount";
import DiscoveryPrompt from "../pages/DiscoveryPrompt";
import UserBank from "../pages/UserBank";
import VerifyBankOtp from "../pages/VerifyLinkBankOtp";
import VerifyOtp from "../pages/VerifyOtp";
import FooterComponent from "../pages/FooterComponent";
import AlternateNumber from "../pages/AlternateNumber";
import Login from "../pages/Login";
import SelectAccountType from "../pages/SelectAccountType";
import DiscoveryLoader from "../pages/DiscoveryLoader";
import LinkOtpQueue from "../pages/LinkOtpQueue";
import Dashboard from "../pages/Dashboard";
import VerifyPin from "../pages/VerifyPin";
import SetPin from "../pages/SetPin";

const AppRouter: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/connectCams" element={<ConnectCams />} />
            <Route path="/connectionFailed" element={<ConnectionFailed />} />
            <Route path="/consentDeny" element={<ConsentDeny />} />
            <Route path="/consentDetails" element={<ConsentDetails />} />
            <Route path="/successRedirect" element={<SuccessRedirect />} />
            <Route path="/userAccounts" element={<UserBankAccount />} />
            <Route path="/userBank" element={<UserBank />} />
            <Route path="/discoveryPrompt" element={<DiscoveryPrompt />} />
            <Route path="/verifyLinkBankOtp" element={<VerifyBankOtp />} />
            <Route path="/verifyOtp" element={<VerifyOtp />} />
            <Route path="/selectAccountType" element={<SelectAccountType />} />
            <Route path="/discoveryLoader" element={<DiscoveryLoader />} />
            <Route path="/linkOtpQueue" element={<LinkOtpQueue />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/verifyPin" element={<VerifyPin />} />
            <Route path="/setPin" element={<SetPin />} />
            <Route path="/footerComponent" element={<FooterComponent />} />
            <Route path="/alternateNumber" element={<AlternateNumber />} />
            {/* fallback route */}
            <Route path="*" element={<Login />} />
        </Routes>
    );
};

export default AppRouter;
